import { forwardRef } from 'react';
import { Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';

// @mui
import { Box, Stack, Typography } from '@mui/material';

import { SimGlobalMenus, SimMenuColumns } from '../menus';


// ==============================|| Page Body ||============================== //
const PageBody = forwardRef((
  {
    title = '',
    menus = [],
    selectedIndex,
    onClick,
    ...other
  },
  ref
) => {
  return (
    <SimMenuColumns
      sidebar={
        <Stack>
          {
            title && (
              <Typography variant={'h4'} py={1.25}>
                {title}
              </Typography>
            )
          }
          
          <SimGlobalMenus
            list={menus}
            onClick={onClick}
            selectedIndex={selectedIndex}
          />
        </Stack>
      }
    >
      <Box minHeight={500} position={'relative'} overflow={'hidden'}>
        <Outlet />
      </Box>
    </SimMenuColumns>
  )
});

PageBody.propTypes = {
  title: PropTypes.string,
  menus: PropTypes.array,
  selectedIndex: PropTypes.string,
  onClick: PropTypes.func,
};

export default PageBody;
